// import axios from 'axios';
import React, { useState } from 'react';
import './InputData.styl';

function InputLyrPM(props) {
  return (
    <div className="data-customization-external-geojson-form">

      <div className="data-customization-panel__input__container2">
        <input
          type="text"
          value={props.LyrPM}
          onChange={e => props.setLyrPM(e.target.value)}
          className="data-customization-panel__input"
          placeholder={props.placeholder}
        />
      </div>
    
    </div>
  )
}
export default InputLyrPM